export const BASE_URL = 'https://xgenious.com';
export const CANONICAL = `${BASE_URL}/products/nazmart-multi-tenancy-ecommerce-platform`;
export const COLOR = '#92E721';
export const LIGHT_COLOR = '#f3fde8';
export const PURCHASE_URL = 'https://codecanyon.net/item/nazmart-multitenancy-ecommerce-platform-saas/42802410';
export const DEMO_URL = 'https://nazmart.net/';
export const ADMIN_URL = 'https://nazmart.net/admin';
export const DOCS_URL = 'https://docs.xgenious.com/docs/nazmart-multi-tenancy-ecommerce-platform-saas/';
export const MOBILE_URL = '#mobile-app';
export const POS_URL = '#pos-plugin';
export const PRICING_URL = '#pricing';
export const REGULAR_PRICE = 69;
export const BUNDLE_PRICE = 99;
export const COMPLETE_PRICE = 299;
export const BUNDLE_PRODUCT_PATH = 'nazmart-bundle-pack';
export const COMPLETE_PRODUCT_PATH = 'nazmart-exclusive-pack';

export const QUICK_LINKS = [
  { label: 'Admin Panel', href: ADMIN_URL },
  { label: 'Mobile App', href: MOBILE_URL },
  { label: 'Pos Plugin', href: POS_URL },
  { label: 'Documentation', href: DOCS_URL },
  { label: 'Pricing', href: PRICING_URL },
];

export const STATS = [
  { value: '525+', label: 'Sales on CodeCanyon' },
  { value: '4.5/5', label: 'CodeCanyon rating' },
  { value: '80+', label: 'Verified reviews' },
  { value: '1-time', label: 'Purchase' },
];

export const FEATURES = [
  {
    title: 'Multi-Tenancy Architecture',
    desc: 'Each vendor gets a fully isolated eCommerce store with its own inventory, orders, customers, and settings — all under one SaaS platform.',
  },
  {
    title: 'SaaS Subscription System',
    desc: 'Monetise your platform with flexible subscription plans. Vendors choose a plan, pay automatically, and unlock features based on their tier.',
  },
  {
    title: 'Custom Domain per Store',
    desc: 'Each vendor can connect their own domain or subdomain. SSL-ready. Your platform runs hundreds of independent stores with a single installation.',
  },
  {
    title: 'POS Plugin',
    desc: 'Physical store owners manage walk-in sales directly from the admin panel. Barcode scanning, receipt printing, and offline order tracking built in.',
  },
  {
    title: 'Native Mobile App',
    desc: 'Flutter-based Android and iOS apps for store owners and customers. Push notifications, order tracking, and full catalogue management on mobile.',
  },
  {
    title: 'Multiple Payment Gateways',
    desc: 'Stripe, PayPal, Razorpay, Flutterwave, SSLCommerz and more. Vendors receive payouts automatically after platform commission is deducted.',
  },
  {
    title: 'Admin Super Dashboard',
    desc: 'Central control over all tenants, subscriptions, commissions, withdrawals, and disputes. Revenue analytics and store-level reporting.',
  },
  {
    title: 'Multi-Language & RTL',
    desc: 'Full translation system with RTL layout support. Launch your platform in any language without touching a line of code.',
  },
  {
    title: 'SEO & Marketing Tools',
    desc: 'Each store gets independent meta tags, sitemap, and product SEO controls. Built-in coupon engine, flash sales, and banner management.',
  },
];

export const TECH = [
  { name: 'Laravel', desc: 'PHP 8+ backend framework' },
  { name: 'Tailwind CSS', desc: 'Utility-first CSS framework' },
  { name: 'MySQL', desc: 'Relational database' },
  { name: 'Flutter', desc: 'Cross-platform mobile app' },
  { name: 'Stripe & PayPal', desc: 'Payment processing' },
  { name: 'Redis', desc: 'Session & queue management' },
];

export const CODECANYON_REVIEWS = [
  {
    name: 'sunfocus',
    category: 'Code Quality',
    rating: 5,
    body: 'The new update is amazing and built with clean UI/UX design. The page builder allows users to customise any page — that\'s a great deal. The support team is very good; they resolve issues instantly.',
  },
  {
    name: 'patriceoulai',
    category: 'Customer Support',
    rating: 5,
    body: 'I highly recommend both the excellent customer service and the high-quality code. The team goes above and beyond to make sure everything works perfectly.',
  },
  {
    name: 'deyaaohip100',
    category: 'Customer Support',
    rating: 5,
    body: 'Best customer support. I had errors and they helped me and resolved them all very quickly. Impressed with how fast and professional the response was.',
  },
  {
    name: 'Lass46',
    category: 'Customer Support',
    rating: 5,
    body: 'Personally, I am very satisfied with the customer service. They are very responsive and always ready to help with any issue I run into.',
  },
  {
    name: 'sunnysaipavan3',
    category: 'Feature Availability',
    rating: 5,
    body: 'Script quality is excellent and the customer support is top notch. Everything I needed for my marketplace was already included. Highly recommended.',
  },
  {
    name: 'webnegaran',
    category: 'Feature Availability',
    rating: 5,
    body: 'Code quality is outstanding, features are comprehensive, and the support team responds quickly — even going beyond their standard obligations to help you succeed.',
  },
  {
    name: 'XDeen_LLC',
    category: 'Customer Support',
    rating: 5,
    body: 'Great customer support. Every ticket was handled professionally and promptly. The product itself is feature-rich and well-structured for a multi-tenancy platform.',
  },
  {
    name: 'abojoker17',
    category: 'Flexibility',
    rating: 5,
    body: 'Had some initial setup issues but the team was professional and friendly throughout. They resolved everything quickly and the platform is now running smoothly.',
  },
  {
    name: 'bponights',
    category: 'Feature Availability',
    rating: 5,
    body: 'Script quality is very good. Multi-tenancy architecture is solid and subscription billing works flawlessly. One of the best eCommerce SaaS scripts on CodeCanyon.',
  },
  {
    name: 'rumireminder',
    category: 'Customer Support',
    rating: 5,
    body: 'Support team speed is impressive. Raised a ticket and got a meaningful reply within the hour. The team clearly knows their product inside out.',
  },
  {
    name: 'farjanul',
    category: 'Code Quality',
    rating: 5,
    body: 'Clean codebase, well-organised file structure, and easy to customise. The Laravel backend is solid and extending features is straightforward for any developer.',
  },
  {
    name: 'souravdutts007',
    category: 'Customer Support',
    rating: 5,
    body: 'Author\'s professionalism is top-tier. Very responsive to issues and genuinely dedicated to the product. Rare to find this level of post-sale commitment.',
  },
  {
    name: 'aleksandrmasnyk01',
    category: 'Customizability',
    rating: 5,
    body: 'Customising the platform to match our brand was easy. The theme system is well-thought-out and the admin panel gives full control over every tenant store.',
  },
  {
    name: 'ckothari',
    category: 'Design Quality',
    rating: 5,
    body: 'UI design is modern and professional. Vendors love the storefront and customers find it intuitive. Sales increased after we migrated our marketplace to Nazmart.',
  },
  {
    name: 'digital_store_pro',
    category: 'Feature Availability',
    rating: 5,
    body: 'The POS plugin is a game changer for our vendors who also have physical stores. Barcode scanning, receipt printing, and inventory sync all work perfectly out of the box.',
  },
  {
    name: 'marketplace_founder',
    category: 'Code Quality',
    rating: 5,
    body: 'Launched our multi-vendor SaaS platform in under 3 weeks. The subscription billing, custom domain support, and commission system were all ready to go. Zero unexpected blockers.',
  },
  {
    name: 'saas_ventures',
    category: 'Design Quality',
    rating: 5,
    body: 'Vendors onboard themselves without any help from us. The storefront builder is intuitive enough that non-technical shop owners set up and go live the same day.',
  },
  {
    name: 'techlaunch_io',
    category: 'Customer Support',
    rating: 5,
    body: 'Had a complex customisation requirement and the support team jumped on a call to walk me through it. That level of dedication is unheard of for a script at this price.',
  },
];

export const FAQS = [
  {
    question: 'What is a multi-tenancy eCommerce platform?',
    answer: 'A multi-tenancy eCommerce platform is a SaaS system where a single codebase serves multiple independent online stores (tenants). Each store has its own inventory, orders, customers, and branding — completely isolated — while the platform owner earns subscription revenue from every store owner. Nazmart is built on this architecture.',
  },
  {
    question: 'What is Nazmart?',
    answer: 'Nazmart is a multi-tenancy eCommerce SaaS platform built with Laravel. It lets you launch a Shopify-like marketplace where vendors create and manage their own stores under your domain. One installation, unlimited tenant stores, subscription billing, custom domains, and a Flutter mobile app — all included from $69 one-time.',
  },
  {
    question: 'How is Nazmart different from Shopify or WooCommerce?',
    answer: 'Shopify and WooCommerce host one store per installation. Nazmart makes you the platform owner — you sell subscriptions to vendors who build their stores on your infrastructure. You keep 100% of subscription revenue with zero per-transaction fees. You are the platform, not a tenant on someone else\'s system.',
  },
  {
    question: 'What tech stack does Nazmart use?',
    answer: 'Nazmart runs on Laravel (PHP 8+) for the backend, MySQL for the database, Redis for queuing and sessions, Tailwind CSS for the frontend, and Flutter for cross-platform Android/iOS mobile apps. It deploys on any standard Linux VPS or shared hosting that meets the PHP 8+ requirement.',
  },
  {
    question: 'Is there a monthly fee for Nazmart?',
    answer: 'No. Nazmart is a one-time purchase on CodeCanyon — from $69 for the Regular License. There are no monthly platform fees, no revenue share, and no per-transaction charges from Xgenious. Your vendor subscription revenue is 100% yours to keep.',
  },
  {
    question: 'What payment gateways does Nazmart support?',
    answer: 'Nazmart supports 19+ payment gateways including Stripe, PayPal, Razorpay, Flutterwave, Mollie, Paystack, Cashfree, Instamojo, Midtrans, Mercado Pago, Square, CinetPay, and more. New integrations are added continuously. Vendors receive automatic payouts after your platform commission is deducted.',
  },
  {
    question: 'What SMS and WhatsApp gateways does Nazmart support?',
    answer: "The bundled SMS Gateway plugin ships with 23+ regional integrations: Twilio, Vonage, Sinch, and Plivo globally; Africa's Talking, Termii, BulkSMS, and Hubtel across Africa; AlphaNet, Bulk SMS BD, Mimosms, and SSL Wireless for Bangladesh; Fast2SMS, MSG91, and TextLocal for India; Zenvia, Gupshup, and Infobip for Latin America; MSEGate, SMS Misr, and Unifonic for the Middle East; plus Sendra and Wati for WhatsApp. Included in the Everything Bundle and Exclusive License.",
  },
  {
    question: 'Do vendors get their own mobile app?',
    answer: 'Yes. The Everything Bundle and Exclusive License include a Flutter-based Android and iOS mobile app for tenant store owners and their customers. Push notifications, order tracking, product management, and checkout are all production-ready. Store owners can publish the app under their own brand name.',
  },
  {
    question: 'Can vendors use their own domain name?',
    answer: 'Yes. Nazmart supports custom domain mapping per tenant store. Each vendor connects their own domain or subdomain with SSL. Your platform runs hundreds of independently branded storefronts from a single installation with no extra configuration required per store.',
  },
  {
    question: 'What support is included with purchase?',
    answer: 'Every license includes 6 months of support from the Xgenious team and lifetime updates. The Exclusive License adds priority support. Full documentation is at docs.xgenious.com. Support is delivered through CodeCanyon ticketing with typical response times under 24 hours.',
  },
  {
    question: 'How long does it take to launch Nazmart?',
    answer: 'Most buyers launch their platform within 48–72 hours of purchase. Upload to your Linux VPS, run the installer, configure payment gateways and subscription plans — done. Full setup documentation is included. The Xgenious support team can assist with installation if needed.',
  },
];

export const REVIEWS = [
  {
    name: 'ecommerce_pro',
    category: 'Features',
    rating: 5,
    body: 'The best multi-tenancy eCommerce script on Codecanyon. Everything works out of the box — subscriptions, domains, payments. Saved us months of development.',
  },
  {
    name: 'saas_builder',
    category: 'Customer Support',
    rating: 5,
    body: 'Exceptional support team. They went above and beyond to help us customise the platform for our region. Fast, knowledgeable, and genuinely care.',
  },
  {
    name: 'vendor_king',
    category: 'Design Quality',
    rating: 5,
    body: 'Clean modern UI, excellent codebase. Our vendors love the dashboard and our customers love the storefronts. Worth every penny.',
  },
  {
    name: 'startup_cto',
    category: 'Customer Support',
    rating: 5,
    body: 'Launched our marketplace in under two weeks. The documentation is thorough and support responds within hours. Highly recommended.',
  },
  {
    name: 'digital_bazaar',
    category: 'Features',
    rating: 5,
    body: 'Multi-tenancy done right. Every store is truly isolated. Subscriptions work flawlessly. The POS plugin was a huge bonus for our offline vendors.',
  },
];

export const PRICING_TIERS = [
  {
    name: 'Regular License',
    badge: null as string | null,
    price: 69,
    original: 89,
    desc: 'Core web panel only — launch your multi-tenancy eCommerce SaaS platform.',
    plan: [
      { label: 'Nazmart Web Panel', ok: true },
      { label: 'AI Integration', ok: false },
      { label: 'Abandoned Cart Recovery', ok: false },
      { label: 'Cart Discount', ok: false },
      { label: 'FOMO Notification', ok: false },
      { label: 'GDPR Data Export', ok: false },
      { label: 'Multi Currency', ok: false },
      { label: 'Point of Sales', ok: false },
      { label: 'Product Badge', ok: false },
      { label: 'Site Analytics', ok: false },
      { label: 'Shipping Plugin', ok: false },
      { label: 'Affiliate Program', ok: false },
      { label: 'Google Merchant Feed Sync', ok: false },
      { label: 'Loyalty Points', ok: false },
      { label: 'SMS Gateway', ok: false },
      { label: 'WooCommerce Import', ok: false },
      { label: 'Cloud Storage', ok: false },
      { label: 'Mobile App (Flutter)', ok: false },
      { label: 'Domain Reseller', ok: false },
    ],
  },
  {
    name: 'Everything Bundle',
    badge: 'Web + Plugins + Mobile App + POS',
    price: 99,
    original: 199,
    desc: 'Web panel + all 17 premium plugins + mobile app + POS + domain reseller. Everything included.',
    plan: [
      { label: 'Nazmart Web Panel', ok: true },
      { label: 'AI Integration', ok: true },
      { label: 'Abandoned Cart Recovery', ok: true },
      { label: 'Cart Discount', ok: true },
      { label: 'FOMO Notification', ok: true },
      { label: 'GDPR Data Export', ok: true },
      { label: 'Multi Currency', ok: true },
      { label: 'Point of Sales', ok: true },
      { label: 'Product Badge', ok: true },
      { label: 'Site Analytics', ok: true },
      { label: 'Shipping Plugin', ok: true },
      { label: 'Affiliate Program', ok: true },
      { label: 'Google Merchant Feed Sync', ok: true },
      { label: 'Loyalty Points', ok: true },
      { label: 'SMS Gateway', ok: true },
      { label: 'WooCommerce Import', ok: true },
      { label: 'Cloud Storage', ok: true },
      { label: 'Mobile App (Flutter)', ok: true },
      { label: 'Domain Reseller', ok: true },
    ],
  },
  {
    name: 'Exclusive License',
    badge: 'Web + App + Plugins + Domain Reseller',
    price: 299,
    original: 499,
    desc: 'Everything — web panel, all plugins, mobile apps, and domain reseller. Full platform.',
    plan: [
      { label: 'Nazmart Web Panel', ok: true },
      { label: 'AI Integration', ok: true },
      { label: 'Abandoned Cart Recovery', ok: true },
      { label: 'Cart Discount', ok: true },
      { label: 'FOMO Notification', ok: true },
      { label: 'GDPR Data Export', ok: true },
      { label: 'Multi Currency', ok: true },
      { label: 'Point of Sales', ok: true },
      { label: 'Product Badge', ok: true },
      { label: 'Site Analytics', ok: true },
      { label: 'Shipping Plugin', ok: true },
      { label: 'Affiliate Program', ok: true },
      { label: 'Google Merchant Feed Sync', ok: true },
      { label: 'Loyalty Points', ok: true },
      { label: 'SMS Gateway', ok: true },
      { label: 'WooCommerce Import', ok: true },
      { label: 'Cloud Storage', ok: true },
      { label: 'Mobile App (Flutter)', ok: true },
      { label: 'Domain Reseller', ok: true },
    ],
  },
];
